<template>
	<div class="bottom">
		<div class="bottom__content">
			<router-link :to="link3" class="bottom__right bottom__item" @click.native="sendEvent(event3, event3_m)">
				<div class="bottom__image"><slot name="image-3"></slot></div>
				<div class="bottom__text">
					<div class="bottom__title"><slot name="title-3"></slot></div>
					<div class="bottom__subtitle"><slot name="subtitle-3"></slot></div>
					<div class="bottom__more">Подробнее</div>
				</div>
			</router-link>
			<router-link :to="link1" class="bottom__left bottom__item" @click.native="sendEvent(event1, event1_m)">
				<div class="bottom__image"><slot name="image-1"></slot></div>
				<div class="bottom__text">
					<div class="bottom__title"><slot name="title-1"></slot></div>
					<div class="bottom__subtitle"><slot name="subtitle-1"></slot></div>
					<div class="bottom__more">Подробнее</div>
				</div>
			</router-link>
			<router-link :to="link2" class="bottom__right bottom__item" @click.native="sendEvent(event2, event2_m)">
				<div class="bottom__image"><slot name="image-2"></slot></div>
				<div class="bottom__text">
					<div class="bottom__title"><slot name="title-2"></slot></div>
					<div class="bottom__subtitle"><slot name="subtitle-2"></slot></div>
					<div class="bottom__more">Подробнее</div>
				</div>
			</router-link>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Footer from '@/components/Footer'
	export default {
		data() {
			return {

			}
		},
		props: {
			colorClass: String,
			link1: String,
			link2: String,
			link3: String,
			event1: String,
			event1_m: String,
			event2: String,
			event2_m: String,
			event3: String,
			event3_m: String,
		},
		components: {
			Footer,
		},
		methods: {
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		}
	}
</script>

<style lang="sass">
	.bottom
		&__content
			display: flex
			justify-content: space-between
			@media screen and (max-width: 1000px)
				flex-direction: column
		&__item
			&:hover
				&>.bottom__text .bottom__more
					max-height: 100px
					display: inline-block
					border-bottom: 1px solid rgba(255,255,255,0.5)
				&>.bottom__image
					img
						transform: scale(1.1)
		&__more
			max-height: 0
			overflow: hidden
			position: relative
			transition: all 600ms
			font-family: 'Montserrat'
			line-height: vw(20px)
			margin-top: vw(30px)
			font-family: vw(16px)
			color: #fff
			@media screen and (max-width: 1000px)
				display: none !important
		&__left
			width: 50%
			height: vw(357px)
			text-decoration: none
			display: flex
			align-items: center
			justify-content: center
			position: relative
			@media screen and (max-width: 1000px)
				height: vwm(332px)
				width: 100%
				overflow: hidden
				position: relative
				border-bottom: 1px solid #fff
		&__image
			width: 100%
			position: relative
			overflow: hidden
			@media screen and (max-width: 1000px)
				margin-top: 0px
			img
				width: 140%
				transition: all 300ms
				display: block
				@media screen and (max-width: 1000px)
					width: 160vw
					margin-left: -3vw
		&__right
			width: 50%
			height: vw(357px)
			text-decoration: none
			display: flex
			align-items: center
			justify-content: center
			position: relative
			@media screen and (max-width: 1000px)
				height: vwm(332px)
				overflow: hidden
				position: relative
				border-bottom: 1px solid #fff
				width: 100%
		&__title
			font-size: vw(30px)
			line-height: vw(40px)
			text-transform: uppercase
			font-family: 'Oswald'
			color: $white
			margin-bottom: vw(16px)
			@media screen and (max-width: 1000px)
				font-size: vwm(30px)
				line-height: vwm(40px)
				margin-bottom: vwm(16px)
		&__subtitle
			font-size: vw(20px)
			font-family: 'Montserrat'
			color: $white
			@media screen and (max-width: 1000px)
				font-size: vwm(17px)
		&__text
			position: absolute
			top: 0
			bottom: 0
			margin: auto
			height: vw(210px)
			left: vw(67px)
			@media screen and (max-width: 1000px)
				top: vwm(98px)
				height: auto
				left: vwm(20px)
</style>